import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class UserService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async retrieveUsers() {
        return fetch(this.environmentService.getEnvironmentHost() + "/api/Users", {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            }
        }).then(response => {
            if (!response.ok) {
                console.log("response was:" + response.status);
            }
            return response.json();
        })
            .then(json => {
                return json;
            })
    }

    async getMe() {
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Users/Me", {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            }
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json()
            return data;
        }
        else {
            return result;
        }
    }

    async getUserDetails(userUuid){
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Users/Detail?user=" + userUuid, {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            }
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json()
            return data;
        }
        else {
            return result;
        }
    }

    async changeUserState(uuid, state){

        let userstateChangeObject = {
            user: uuid,
            state : state
        }

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Users/state", {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token"),
                "Content-type": "application/json"
            },
            method: "PUT",
            body: JSON.stringify(userstateChangeObject)
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json()
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/userService.js